import React, { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from './ui/input';

/**
 * Password input with a Show/Hide eye toggle.
 * Forwards all native input props (value, onChange, placeholder, required, minLength, etc.)
 * to <Input>, and accepts a `data-testid` for the field and an optional `toggleTestId`
 * for the eye button (defaults to `${data-testid}-toggle`).
 */
const PasswordInput = forwardRef(({ className = '', toggleTestId, ...props }, ref) => {
  const [shown, setShown] = useState(false);
  const fieldTestId = props['data-testid'];
  const btnTestId = toggleTestId || (fieldTestId ? `${fieldTestId}-toggle` : 'password-toggle');

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={shown ? 'text' : 'password'}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShown((v) => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-900 focus:outline-none"
        aria-label={shown ? 'Hide password' : 'Show password'}
        tabIndex={-1}
        data-testid={btnTestId}
      >
        {shown ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
